// extracted by mini-css-extract-plugin
module.exports = {"errorWrapper":"error_errorWrapper__36i_l","biggerText":"error_biggerText__qwRNt","primaryButton":"error_primaryButton__14I8F"};